import { React, useEffect, useState } from "react";
import AppButton from "./AppButton.component";
import {
  FormControl,
  InputLabel,
  OutlinedInput,
  FormHelperText,
  Button,
  Box,
  Divider,
  CircularProgress,
  Autocomplete,
  TextField,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/system";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import { useParams } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/client";
import {
  SEND_EMAIL,
  CREATE_CUSTOMER,
  SEND_TEXT,
} from "../../graphql/mutation/mutation.js";

import { InputValidation } from "../../utils/InputValidationRegex";
import { useAuth } from "../../context/Auth.context";
import {
  appUrl,
  closeWindow,
  delay,
  firstOfMonth,
  today,
} from "../../utils/Utils";
import { CheckCircle } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../context/App.context";
import { FETCH_API_TRANSACTION, FETCH_YMMT } from "../../graphql/query/query";
import ecLogo from "../../assets/images/delivery.png";
import { useVerification } from "../../context/Verification.context.jsx";
const INITIAL_CUSTOMER_STATE = {
  firstName: "",
  lastName: "",
  vin: "",
  email: "",
  mobileNumber: "",
  year: "",
  make: "",
  model: "",
};
const currentYear = new Date().getFullYear() + 1;
const getLast15Years = Array.from(
  { length: 15 },
  (_, index) => currentYear - index
);

const UserDetails = ({ onClose, isURL = false }) => {
  const theme = useTheme();
  const auth = useAuth();
  const params = useParams();
  console.log("checkParams", params);
  const app = useAppContext();
  const navigate = useNavigate();
  const verification = useVerification();

  const [saveYear, setSaveYear] = useState(null);
  const [saveMake, setSaveMake] = useState(null);
  const [saveModel, setSaveModel] = useState(null);
  const [saveTrim, setSaveTrim] = useState(null);
  const [saveCustomer, setSaveCustomer] = useState({
    email: false,
    continue: false,
    text: false,
  });
  const [customer, setCustomer] = useState(INITIAL_CUSTOMER_STATE);

  useEffect(() => {
    if (customer.userId) {
      if (saveCustomer.email) {
        emailHandler(customer.userId);
      } else if (saveCustomer.text) {
        textHandler(customer.userId);
      } else if (saveCustomer.continue) {
        continueHandler(isURL);
      }
    }
  }, [customer.userId]);

  useEffect(() => {
    app.setFetchData({
      d_startDate: firstOfMonth,
      d_endDate: today,
      f_startDate: firstOfMonth,
      f_endDate: today,
      pageCount: 0,
      rowsPerPage: 25,
      searchEmployee: "",
      searchCustomer: "",
    });
  }, []);
  const {
    data: apiFetchTransaction,
    loading: transactionLoading,
    error: err,
  } = useQuery(FETCH_API_TRANSACTION, {
    variables: {
      apiFetchInput: {
        transaction_id: params.transactionId,
      },
    },
  });
  console.log("apiFetchTransaction", apiFetchTransaction?.apifetchTransaction);

  useEffect(() => {
    if (apiFetchTransaction?.apifetchTransaction?.data) {
      let getDetails = JSON.parse(
        apiFetchTransaction?.apifetchTransaction?.data
      );
      console.log("getDetails", getDetails);
      setCustomer(getDetails);
      if (apiFetchTransaction?.apifetchTransaction?.image_url) {
        verification.setDealershipLogo(
          apiFetchTransaction?.apifetchTransaction?.image_url
        );
      }
      console.log("cusstomerr", customer);
    }
  }, [apiFetchTransaction]);
  const [createCustomer, { loading: customerLoading }] = useMutation(
    CREATE_CUSTOMER,
    {
      onCompleted: async (data) => {
        if (data?.createCustomer?.user_id) {
          console.log("datas", data);
          setCustomer({
            ...customer,
            userId: data.createCustomer.user_id,
            vehicleId: data.createCustomer.vehicle_id,
          });
        } else {
          console.log("customer not saved");
        }
      },
    }
  );

  const [sendEmail, { loading, data }] = useMutation(SEND_EMAIL, {
    onCompleted: async (data) => {
      if (data) {
        setCustomer(INITIAL_CUSTOMER_STATE);
        await delay(1000);
        setTimeout(() => {
          console.log("closee");
          closeWindow();
        }, 1000);
      }
    },
  });

  const [sendText, { loading: textLoading, data: textData }] = useMutation(
    SEND_TEXT,
    {
      onCompleted: async (data) => {
        if (data) {
          setCustomer(INITIAL_CUSTOMER_STATE);
          await delay(1000);
          // onClose();
          setTimeout(() => {
            console.log("closee");
            closeWindow();
          }, 1000);
        }
      },
    }
  );

  const emailHandler = async (userId) => {
    if (
      !InputValidation.emailValidation(customer.email) &&
      customer.email !== ""
    ) {
      sendEmail({
        variables: {
          verificationRequestInput: {
            user: {
              user_id: userId,
              first_name: customer.firstName,
              middle_name: " ",
              last_name: customer.lastName,
              vin: customer.vin,
              email: customer.email,
              phone_number: customer.mobileNumber,
            },
            employee: {
              employee_user_id:
                apiFetchTransaction?.apifetchTransaction?.employee_user_id ||
                auth.user.user_id.toString(),
              employee_firstname:
                apiFetchTransaction?.apifetchTransaction?.first_name ||
                auth.user.first_name,
              employee_lastname:
                apiFetchTransaction?.apifetchTransaction?.last_name ||
                auth.user.last_name,
            },
            url:
              appUrl +
              `/verification/consent/${
                apiFetchTransaction?.apifetchTransaction?.employee_user_id ||
                auth.user.user_id
              }/${apiFetchTransaction?.apifetchTransaction?.dealership_id}/${
                customer.userId
              }`,
            dealership: {
              dealership_name:
                apiFetchTransaction?.apifetchTransaction?.dealership_name ||
                auth.user.dealership_name,
            },
          },
        },
      });
    }
  };

  const textHandler = async (userId) => {
    if (
      !InputValidation.numberValidation(customer.mobileNumber) &&
      customer.mobileNumber !== ""
    ) {
      sendText({
        variables: {
          verificationRequestInput: {
            user: {
              user_id: userId,
              first_name: customer.firstName,
              middle_name: " ",
              last_name: customer.lastName,
              vin: customer.vin,
              email: customer.email,
              phone_number: customer.mobileNumber,
            },
            employee: {
              employee_user_id:
                apiFetchTransaction?.apifetchTransaction?.employee_user_id ||
                auth.user.user_id.toString(),
              employee_firstname:
                apiFetchTransaction?.apifetchTransaction?.first_name ||
                auth.user.first_name,
              employee_lastname:
                apiFetchTransaction?.apifetchTransaction?.last_name ||
                auth.user.last_name,
            },
            url:
              appUrl +
              `/verification/consent/${
                apiFetchTransaction?.apifetchTransaction?.employee_user_id
              }/${
                apiFetchTransaction?.apifetchTransaction?.dealership_id ||
                auth.user.dealership_id
              }/${customer.userId}`,
            dealership: {
              dealership_name:
                apiFetchTransaction?.apifetchTransaction?.dealership_name ||
                auth.user.dealership_name,
            },
          },
        },
      });
    }
  };

  const saveCustomerHandler = async () => {
    console.log(" params?.dealershipId", params?.dealershipId);
    await createCustomer({
      variables: {
        customerInput: {
          first_name: customer.firstName,
          last_name: customer.lastName,
          email: customer.email,
          mobile_number: customer.mobileNumber,
          vin: customer.vin,
          year: customer?.year,
          make: customer?.make,
          model: customer?.model,
          trim: customer?.trim,
          employee_user_id:
            apiFetchTransaction?.apifetchTransaction?.employee_user_id ||
            auth?.user?.user_id,
          dealership_id:
            apiFetchTransaction?.apifetchTransaction?.dealership_id ||
            auth?.user?.dealership_id,
          d_startDate: app.fetchData.d_startDate || firstOfMonth,
          d_endDate: app.fetchData.d_endDate || today,
          f_startDate: app.fetchData.f_startDate || firstOfMonth,
          f_endDate: app.fetchData.f_endDate || today,
          pageCount: app.fetchData.pageCount || 0,
          rowsPerPage: app.fetchData.rowsPerPage || 25,
          search_employee: app.fetchData.searchEmployee || "",
          search_customer: app.fetchData.searchCustomer || "",
          isEmployeeOnly: false,
          timezone: new Date().getTimezoneOffset(),
          verification_url: JSON.stringify(customer),
          isApiService: true,
          transaction_id: params?.transactionId,
        },
      },
    });
  };

  const continueHandler = async (isURL) => {
    if (isURL) {
      console.log("urllll", customer.userId);
      navigate(
        `/verification/consent/${
          apiFetchTransaction?.apifetchTransaction?.employee_user_id ||
          auth?.user?.user_id
        }/${
          apiFetchTransaction?.apifetchTransaction?.dealership_id ||
          auth?.user?.dealership_id
        }/${customer.userId}`
      );
    }
  };

  const getWorkFlowDetails = auth?.user?.associateDetails?.filter((data) => {
    return data?.dealership_id === auth?.user?.dealership_id;
  });
  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="flex-end"
        gap="8px"
        // marginTop="5px"
        // marginBottom="5px"
      >
        <img
          src={
            apiFetchTransaction?.apifetchTransaction?.image_url ||
            auth?.user?.dealership_logo
          }
          width={100}
          height={60}
          alt="logo"
          style={{
            objectFit: "contain",
          }}
        />
        <img
          src={ecLogo}
          width={75}
          height={56.74}
          alt="logo"
          style={{
            objectFit: "contain",
            paddingTop: 15,
          }}
        />
      </Box>
      <Divider />
      <Box
        sx={{
          m: window.innerWidth <= 750 ? "5px" : "0px 5px 0px 5px",
        }}
      >
        <FormControl variant="outlined" fullWidth sx={{ marginBottom: "20px" }}>
          <InputLabel>First Name *</InputLabel>
          <OutlinedInput
            required
            label="First Name"
            value={customer.firstName}
            sx={{ borderRadius: "6px" }}
          />
        </FormControl>

        <FormControl variant="outlined" fullWidth sx={{ marginBottom: "20px" }}>
          <InputLabel>Last Name *</InputLabel>
          <OutlinedInput
            required
            label="Last Name"
            value={customer.lastName}
            sx={{ borderRadius: "6px" }}
          />
        </FormControl>
        <FormControl variant="outlined" fullWidth sx={{ marginBottom: "20px" }}>
          <InputLabel>Email *</InputLabel>
          <OutlinedInput
            required
            label="Email"
            value={customer.email}
            sx={{ borderRadius: "6px" }}
          />
        </FormControl>
        <FormControl variant="outlined" fullWidth sx={{ marginBottom: "20px" }}>
          <InputLabel>Mobile Number *</InputLabel>
          <OutlinedInput
            required={true}
            label="Mobile Number"
            value={InputValidation.phoneNumberFormat(customer.mobileNumber)}
            sx={{ borderRadius: "6px" }}
          />
        </FormControl>

        {apiFetchTransaction?.apifetchTransaction?.workflowId ===
        3 ? null : apiFetchTransaction?.apifetchTransaction.workflowId === 1 ||
          apiFetchTransaction?.apifetchTransaction?.workflowId === 2 ? (
          <>
            <FormControl
              variant="outlined"
              fullWidth
              sx={{ marginBottom: "20px" }}
            >
              <InputLabel>VIN of vehicle being purchased</InputLabel>
              <OutlinedInput
                required
                label=" VIN of vehicle being purchased"
                value={customer.vin || ""}
                sx={{
                  borderRadius: "6px",
                  backgroundColor:
                    customer.year || customer.make || customer.model
                      ? "#e0e0e0"
                      : "white",
                }}
                disabled={customer.year || customer.make || customer.model}
              />
            </FormControl>
            <Box
              display="flex"
              flexDirection={window.innerWidth <= 750 ? "row" : "row"}
              justifyContent="space-between"
              marginBottom={window.innerWidth <= 750 ? 1 : "20px"}
              gap={1}
            >
              <FormControl sx={{ width: "100%" }}>
                <InputLabel
                  sx={window.innerWidth <= 750 ? { fontSize: 15 } : null}
                >
                  Year
                </InputLabel>
                <OutlinedInput
                  label="Year"
                  value={customer.year}
                  disabled={customer.vin}
                  sx={{
                    backgroundColor: customer.vin ? "#e0e0e0" : "white",
                  }}
                ></OutlinedInput>
              </FormControl>
              <FormControl sx={{ width: "100%" }} variant="outlined">
                <InputLabel
                  id="demo-simple-select-label"
                  sx={window.innerWidth <= 750 ? { fontSize: 15 } : null}
                >
                  Make
                </InputLabel>
                <OutlinedInput
                  label="Make"
                  value={customer.make}
                  disabled={customer.vin}
                  sx={{
                    backgroundColor: customer.vin ? "#e0e0e0" : "white",
                  }}
                ></OutlinedInput>
              </FormControl>
              <FormControl sx={{ width: "100%" }}>
                <InputLabel
                  htmlFor="make-select"
                  sx={window.innerWidth <= 750 ? { fontSize: 14 } : null}
                >
                  Model
                </InputLabel>
                <OutlinedInput
                  label="Model"
                  value={customer.model}
                  disabled={customer.vin}
                  sx={{
                    backgroundColor: customer.vin ? "#e0e0e0" : "white",
                  }}
                ></OutlinedInput>
              </FormControl>
            </Box>
          </>
        ) : null}
      </Box>

      {customerLoading ? (
        <CircularProgress
          size={30}
          sx={{
            // marginBottom: "15px",
            alignSelf: "center",
          }}
        />
      ) : (
        <Button
          variant="text"
          onClick={() => {
            setSaveCustomer({ ...saveCustomer, continue: true });
            saveCustomerHandler();
          }}
          // sx={{ mt: "7px" }}
        >
          CONTINUE HERE
        </Button>
      )}

      <>
        <Divider sx={{ mb: 1 }} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "8px",
            width: "100%",
            // mb: "12px",
          }}
        >
          {textData?.sendTextRequest.user_id ? (
            <Box
              sx={{
                display: "flex",
                // my: "14px",
                width: "100%",
                justifyContent: "center",
              }}
            >
              <CheckCircle color={"primary"} />
              <span
                style={{
                  color: theme.palette.primary.main,
                  marginLeft: "4px",
                }}
              >
                TEXT SENT
              </span>
            </Box>
          ) : (
            <AppButton
              buttonText="Send Text"
              loading={textLoading}
              clickHandler={() => {
                setSaveCustomer({ ...saveCustomer, text: true });
                saveCustomerHandler();
              }}
              size="medium"
              variant="outlined"
              sx={{ width: "100%" }}
            />
          )}
          {data?.sendEmailRequest.user_id ? (
            <Box
              sx={{
                display: "flex",
                // my: "14px",
                width: "100%",
                justifyContent: "center",
              }}
            >
              <CheckCircle color={"primary"} />
              <span
                style={{
                  color: theme.palette.primary.main,
                  marginLeft: "4px",
                }}
              >
                EMAIL SENT
              </span>
            </Box>
          ) : (
            <AppButton
              buttonText="Send Email"
              loading={loading}
              clickHandler={() => {
                setSaveCustomer({ ...saveCustomer, email: true });
                saveCustomerHandler();
              }}
              size="medium"
              variant="contained"
              sx={{ width: "100%" }}
            />
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            p: "14px",
          }}
        >
          <Typography variant="body" fontSize={"12px"} color={"grey"}>
            By selecting Send, you confirm that the customer has authorized the
            dealership to send this communication by the selected method.
          </Typography>
        </Box>
      </>

      <NotificationContainer />
    </>
  );
};

export default UserDetails;
